function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { PureComponent } from "react";
//Limitless imports
import { withLogging } from "./Logging";
import { TranslationContext } from "@limitless/common/hooks/translation/TranslationContext";

/**
 * The Internationalisation HOC, uses the resourceBundle in the context to find a translated value
 *
 * @param {React.Component} WrappedComponent
 * @param {string} className
 */
export const withi18n = (WrappedComponent, className) => {
  class TranslatedComponent extends PureComponent {
    render() {
      return /*#__PURE__*/React.createElement(TranslationContext.Consumer, null, context => /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        t: context.t
      }, this.props)));
    }
  }
  if (className) {
    return withLogging(TranslatedComponent, className);
  } else {
    return TranslatedComponent;
  }
};